import { useEffect, useState } from "react";
import { emailTemplateService } from "../services";

/** Flags returned from API TaskTemplate (calendar flows reuse the same shape; `taskCreator` means notify creator). */
export const useEmailTemplate = (templateName: string) => {
  const [emailTemplate, setEmailTemplate] = useState<any>({});
  const [dispatchTemplate, setDispatchTemplate] = useState<any>({});

  useEffect(() => {
    emailTemplateService.getAll().then(async (response: any) => {
      const template = response.find((t: any) => t.name === templateName);
      if (template) {
        setEmailTemplate(template);
        setDispatchTemplate(await emailTemplateService.getById(template.id));
      } else {
        console.error(`${templateName} template not found`);
      }
    });
  }, [templateName]);

  const createEmailArray = async (
    template: any,
    personals: any,
    currentUserEmail: string,
    adminEmail?: string
  ) => {
    const emails: string[] = [];
    const notifyCreator = template?.taskCreator === true || template?.eventCreator === true;
    if (notifyCreator && currentUserEmail) {
      emails.push(currentUserEmail);
    }
    if (template?.adminEmail && adminEmail) {
      emails.push(adminEmail);
    }
    if (template?.personnel && personals) {
      personals.forEach((obj: any) => {
        if (obj?.email) {
          emails.push(obj.email);
        }
      });
    }
    return emails;
  };

  return {
    emailTemplate,
    /** @deprecated use dispatchTemplate - kept for minimal churn in event hooks */
    eventTemplate: dispatchTemplate,
    dispatchTemplate,
    createEmailArray,
  };
};
